import Cookies, {CookieAttributes} from "js-cookie";

export const configCookies: CookieAttributes = {
    expires: 1, // Días hasta la expiración
    sameSite: 'Lax',
    // sameSite: "Strict",
};
// Función para establecer la cookie
export const setCookie = (name: string, value: string) => {
    Cookies.set(name, value, {...configCookies});
};
